import { useOutletContext } from 'react-router-dom'
import { CalculoEspelho } from '@/service/api'

export function useCalculoOutletContext() {
    return useOutletContext<{
        data: CalculoEspelho[]
        /** Funcionários marcados na tabela — pré-seleção nos modais */
        funcionarioIds: number[]
    }>()
}
